'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookLoma = require('@narvar/nth-hook-loma');

const useCreateClaimMutation = () => {
  const [createClaim] = nthHookLoma.useCreateClaimAgentMutation();
  return async options => {
    await createClaim(options);
  };
};

exports["default"] = useCreateClaimMutation;
